// H5P Content Service
import { Subject } from 'rxjs';
import { ContentService } from './h5p-client/services/ContentService.js';

export const contentService = new ContentService('/api/h5p');
export const scrollToTop = new Subject<boolean>();
